import { useEffect, useState, useRef, useCallback } from 'react';

export default function useCountdown(settings) {
  const { initialSecond, onExpire = () => {}, onExpireDelay = 700 } = settings || {};
  // Seconds

  const [seconds, setSeconds] = useState(initialSecond);
  // Control functions
  const intervalRef = useRef(null);
  const pausedRef = useRef(false); // Paused Ref to store the Value, otherwise it will be init every second again

  const pause = useCallback(isPause => {
    pausedRef.current = isPause;
  }, []);

  const reset = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = undefined;
    }
    setSeconds(initialSecond);
  }, [initialSecond]);

  useEffect(() => {
    if (seconds === 0) {
      setTimeout(() => {
        onExpire();
        reset();
      }, onExpireDelay);
    }
  }, [seconds]);

  const subtractSecond = useCallback(() => {
    // Check if the Countdown paused
    if (!pausedRef.current) {
      setSeconds(prevSeconds => {
        console.log(prevSeconds);
        return prevSeconds - 1;
      });
    }
  }, []);

  const start = useCallback(() => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => subtractSecond(), 1000);
    }
  }, [subtractSecond]);

  return { seconds, start, pause, reset };
}
